import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import MailSubscriptionsTab from "./MailSubscriptionsTab";

export default function MailSubscriptionsPage() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <div className="p-6 bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 min-h-[60vh] flex flex-col items-center justify-center text-gray-700 dark:text-gray-300">
        <h2 className="text-xl font-bold mb-2">Erişim Reddedildi</h2>
        <p className="text-sm text-gray-500">Mail aboneliklerini görüntülemek için lütfen giriş yapın.</p>
      </div>
    );
  }

  return (
    <div className="p-2 md:p-4">
      <MailSubscriptionsTab />
    </div>
  );
}
